export default {
  props: {
    address: '7281 Test Drive',
    properties: [
      {
        image: {
          height: '197px',
          src: '/storybook/card-property-image@3x.jpg',
          width: '290px'
        },
        property: {
          address: '1140 Asbury Road',
          alertPills: ['Coming Soon', 'Open House'],
          city: 'Anderson Twp.',
          details: [{ br: 3 }, { ba: '2/0' }, { ac: 0.078 }],
          listingId: 9999999,
          price: '$229,000',
          realtor: {
            isActiveSibcyAgent: true,
            name: '',
            url: ''
          },
          state: 'OH',
          zip: '45255'
        },
        url: '/'
      },
      {
        image: {
          height: '197px',
          src: '/storybook/card-property-image@3x.jpg',
          width: '290px'
        },
        property: {
          address: '8548 Prilla Lane',
          alertPills: ['New Construction'],
          city: 'Anderson Twp.',
          details: [{ br: 2 }, { ba: '2/0' }, { ac: 0.474 }],
          listingId: 8888888,
          price: '$225,000',
          realtor: {
            isActiveSibcyAgent: true,
            name: '',
            url: ''
          },
          state: 'OH',
          zip: '45255'
        },
        url: '/'
      },
      {
        image: {
          height: '197px',
          src: '/storybook/card-property-image@3x.jpg',
          width: '290px'
        },
        property: {
          address: '1399 Wolfangel Road',
          alertPills: ['Pending'],
          city: 'Anderson Twp.',
          details: [{ br: 3 }, { ba: '2/0' }, { ac: 0.165 }],
          listingId: 7777777,
          price: '$220,000',
          realtor: {
            isActiveSibcyAgent: false,
            name: '',
            url: ''
          },
          state: 'OH',
          zip: '45255'
        },
        url: '/'
      }
    ]
  }
};
